import * as Sentry from '@sentry/nextjs';
import { API_URL } from 'constants/api';
import { FirebasePopupProvider } from 'constants/auth';
import { LINK_PROVIDER_API_ROUTE } from 'constants/payloads/users/link-provider';
import { getAuthHeaders } from 'services/client/token';

/**
 * Tells the server to record a newly-linked OAuth provider in the DB (latestAuthProvider +
 * user_auth_identities). Best-effort metadata sync — callers fire-and-forget it. The server
 * re-reads the provider list from Firebase, so this only needs which provider was just linked.
 */
export const syncLinkedProvider = async (provider: FirebasePopupProvider): Promise<void> => {
  const authResult = await getAuthHeaders();
  const authHeaders = 'headers' in authResult ? authResult.headers : {};

  const response = await fetch(`${API_URL}${LINK_PROVIDER_API_ROUTE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
    },
    body: JSON.stringify({ provider }),
  });

  if (!response.ok) {
    Sentry.captureException(new Error(`syncLinkedProvider failed: ${response.status}`), {
      extra: { provider },
    });
  }
};
